var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { updateSearch } from 'bernie-core';
import { parse } from 'query-string';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkCarousel } from 'uitk-react-carousel';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkHeading } from 'uitk-react-text';
import { UitkLink } from 'uitk-react-link';
import { UitkSpacing } from 'uitk-react-spacing';
import { EgdsHeadingTagStyle, UITK_HEADING_SIZE } from '../../../../constants';
import { getSeeAllURL } from '../../../../helpers/common-helper';
import { onClickScrollToTarget } from '../../../../helpers/smooth-scroll';
import { useStores } from '../../../../utils/hooks';
import { ActivityTileCard } from './simple-result-card';
export var ActivityCarousel = function (_a) {
  var activityGroup = _a.activityGroup,
    pageId = _a.pageId;
  var _b = useStores(),
    analytics = _b.analytics,
    searchCriteriaStore = _b.searchCriteriaStore;
  var location = useLocation();
  var history = useHistory();
  if (!pageId) {
    return null;
  }
  var activityTiles = activityGroup.activityTiles,
    action = activityGroup.action,
    type = activityGroup.type;
  var seeAllUrl = '';
  var handleSrpTileClick = function (activity) {
    searchCriteriaStore.scrollPosition = window.pageYOffset;
    if (activity.clientSideAnalytics) {
      analytics.trackEvent(activity.clientSideAnalytics.referrerId, activity.clientSideAnalytics.linkName, analytics.omnitureData);
    }
  };
  var renderActivityCard = function (index, activity, groupType) {
    return React.createElement(ActivityTileCard, {
      key: "acitivity-tile-card-".concat(activity.id),
      tag: "li",
      activity: activity,
      loading: false,
      index: index,
      onClick: function () {
        return handleSrpTileClick(activity);
      },
      activityGroup: groupType
    });
  };
  var handleShowAllClick = function (action) {
    onClickScrollToTarget({
      scrollTo: 0
    });
    analytics.trackEvent(action.analytics.referrerId, action.analytics.linkName, analytics.omnitureData);
    updateSearch({
      history: history,
      location: location,
      newParams: seeAllUrl
    });
  };
  var renderShowAllLink = function (element) {
    return React.createElement(UitkLink, {
      align: "right",
      inline: false,
      size: "large"
    }, React.createElement("button", {
      onClick: function () {
        return handleShowAllClick(action);
      },
      type: "button"
    }, element));
  };
  var CarouselProps = {
    carouselName: 'activity-carousel',
    itemsVisible: {
      lg: 3,
      md: 3,
      sm: 1
    },
    pageBy: 1,
    buttonText: {
      nextButton: 'next',
      prevButton: 'previous'
    },
    navigationIconId: {
      next: 'activity-carousel-next-button-title',
      prev: 'activity-carousel-prev-button-title'
    },
    wrapItems: true,
    itemsMaxHeight: true,
    peek: true
  };
  if (action) {
    var UrlParams = parse(location.search);
    seeAllUrl = getSeeAllURL(action.url, UrlParams);
  }
  var heading = activityGroup.heading;
  return React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'six'
    }
  }, React.createElement("section", {
    className: "activity-list-carousel",
    "data-testid": "".concat(heading === null || heading === void 0 ? void 0 : heading.text, "-activity-carousel--section")
  }, (heading === null || heading === void 0 ? void 0 : heading.text) && React.createElement(UitkLayoutFlex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, React.createElement(UitkSpacing, {
    margin: {
      blockend: 'three'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    minWidth: "full_width"
  }, React.createElement(UitkHeading, {
    tag: heading.headingType ? EgdsHeadingTagStyle[heading.headingType] : 'h2',
    size: UITK_HEADING_SIZE
  }, heading.text))), React.createElement(Viewport, null, React.createElement(ViewMedium, null, React.createElement(React.Fragment, null, action && React.createElement(UitkLayoutFlexItem, null, renderShowAllLink(React.createElement(React.Fragment, null, action.label))))))), activityTiles && (activityTiles.length > 1 ? React.createElement(UitkSpacing, {
    margin: {
      blockend: 'two'
    }
  }, React.createElement(UitkCarousel, __assign({}, CarouselProps), activityTiles.map(function (acitivity, index) {
    return renderActivityCard(index, acitivity, type);
  }))) : renderActivityCard(0, activityTiles[0], type)), React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(React.Fragment, null, action && renderShowAllLink(React.createElement(UitkSecondaryButton, {
    isFullWidth: true
  }, action.label)))), React.createElement(ViewMedium, null))));
};